import { render, staticRenderFns } from "./car-attribute-details-popup.vue?vue&type=template&id=5ea20d2e&scoped=true&"
import script from "./car-attribute-details-popup.vue?vue&type=script&lang=js&"
export * from "./car-attribute-details-popup.vue?vue&type=script&lang=js&"
import style0 from "./car-attribute-details-popup.vue?vue&type=style&index=0&id=5ea20d2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea20d2e",
  null
  
)

export default component.exports